__turbopack_context__.v({
  "cardsContainer": "yEv0AW_cardsContainer",
  "ctaCard": "yEv0AW_ctaCard",
  "getQuoteLabel": "yEv0AW_getQuoteLabel",
});
